/* @ngInject */
const trainRequest = (
  $q,
  trainResource,
  utils,
  valueHandler,
  labels,
  errorHandler
) => {
  const self = {}

  self.getBySearch = async (_data) => {
    return $q((resolve, reject) => {
      const functionName = '$train.getBySearch'
      trainResource.post({
        action: 'search',
      }, { search: _data }, (res) => {
        if (res && res.success && valueHandler.isArray(res.data)) {
          const response = {
            trains: res.data,
            message: labels.train.log.search.success(res.data.length),
            color: res.data.length === 0 ? 'orange' : 'green',
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _data)
          reject(labels.train.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.getByQuickSearch = async (_data) => {
    return $q((resolve, reject) => {
      const functionName = '$train.getByQuickSearch'
      trainResource.post({
        action: 'search',
      }, { search: _data }, (res) => {
        if (res && res.success && valueHandler.isArray(res.data)) {
          const response = {
            trains: res.data,
            message: labels.train.log.search.success(res.data.length),
            color: res.data.length === 0 ? 'orange' : 'green',
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _data)
          reject(labels.train.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.getAll = async () => {
    return self.getBySearch()
  }

  self.getById = async (_trainId) => {
    return $q(async (resolve, reject) => {
      if (!valueHandler.isId(_trainId)) {
        reject("L'id est invalide")
      }
      const data = {
        id: _trainId,
      }

      try {
        const response = await self.getBySearch(data)
        const trains = response.trains
        if (trains.length === 1) {
          resolve(trains[0])
        } else {
          reject(labels.train.log.search.noResultWithId)
        }
      } catch (error) {
        reject(error)
      }
    })
  }

  self.getWagons = async (_trainId) => {
    return $q((resolve, reject) => {
      const functionName = '$train.getWagons'
      trainResource.post({
        action: 'get-wagons',
      }, { trainId: _trainId }, (res) => {
        if (res && res.success && valueHandler.isArray(res.data)) {
          resolve(res.data)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _trainId)
          reject(labels.train.log.getWagons.failure)
        }
      })
    })
  }

  self.save = (_train) => {
    return $q((resolve, reject) => {
      const functionName = '$train.save'

      trainResource.save({}, _train, (res) => {
        if (res && res.success && valueHandler.isId(res.data.id)) {
          const response = {
            id: res.data.id,
            message: labels.train.log.save.success,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          if (res.code === 2) {
            reject(labels.train.log.save.alreadyExists)
          } else {
            errorHandler.message(res, functionName, _train)
            reject(labels.train.log.save.failure)
          }
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.update = (_train) => {
    return $q((resolve, reject) => {
      const functionName = '$train.update'
      trainResource.update({ action: _train.id }, _train, (res) => {
        if (res && res.success) {
          const response = {
            train: res.data,
            message: labels.train.log.update.success,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _train)
          reject(labels.train.log.update.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.delete = async (_id) => {
    return $q((resolve, reject) => {
      const functionName = '$train.delete'
      trainResource.delete({
        action: _id,
      }, (res) => {
        if (res && res.success) {
          resolve(labels.train.log.delete.success)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _id)
          reject(labels.train.log.delete.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  return self
}

export default trainRequest



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/train/services/request.service.js